// @ts-nocheck
/* eslint-disable */
import { CLOSE_16, CHEVRON_LEFT_16, SHARE_FILLED_16, OVERFLOW_MENU_VERTICAL_FILLED, STAR } from "@sznds/icons";
import HeroHeader from "~/ui/heroheader";
import createHeaderButton from "~/ui/headerbutton";
import { addListener } from "~/lib/signals";
import { node, icon } from "~/util/dom";
import { activityTypeToIcon, backAction } from "./util";
import { CONFIG } from "~/config";
import { moodIco } from "~/util/activities";
import { showMarkerLabel } from "~/util/markerTitle";
import { _ } from "~/i18n";
import MyMapsShare from "~/es6/mymaps.share";
import Scene from "~/scene";
import MapInteractiveGeometry from "~/interactiveGeometry";
import InteractiveLineChart from "~/interactivelinechart";
import { store } from "~/state/store";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";
import MyMapsEditActivity from "~/ui/dialogs/mymaps-edit-activity";
import MyMapsLinkActivity from "~/ui/dialogs/mymaps-link-activity";
import { setCoordinates } from "~/state/map/state";
import { standardDistanceFormat, standardTimeFormat } from "~/util/format";
import { createMyMapsSharing } from "~/ui/mymaps/sharing";
import { createUserNote } from "~/ui/user-note/note";
import createSDSIcon from "~/ui/icon";
import { getFolderData, trackListFolders } from "~/util/providers/mapybox";
import { getNoteVersion, isPremiumNoteUser } from "~/util/user-note";
import MyMapsBox from "~/ui/mymaps/box";
import { getUserTime, mymapsOpenActivities, mymapsOpenFolder } from "~/util/mapybox";
import MyMapsExport from "~/ui/dialogs/mymaps-export";
import { MYMAPS_SHARE } from "~/ui/sds-compatible-icons";
import MyMapsRemove from "~/ui/dialogs/mymaps-remove";
import MyMapsMoveItems from "~/ui/dialogs/mymaps-move-items";
import { IMapyBoxItem } from "~/interfaces";
import { getIcon as contextmenuGetIcon, getTitle as contextmenuGetTitle } from "~/es6/mymaps.contextmenu";
import ContextMenu from "~/ui/contextmenu";
import ContextMenuItem from "~/ui/contextmenuitem";
import WasmStoreMarker from "~/wasm/store/wasm-store-marker";
import WasmStoreGeometry from "~/wasm/store/wasm-store-geometry";
import { WASM_ZINDEX } from "~/wasm/const";

export default class ActivityDetail {
	_wasmMarkers: Array<WasmStoreMarker>;

	_wasmGeometry: WasmStoreGeometry;

	constructor () {
		this._data = null;
		this._tid = null;
		this._active = false;
		this._show = false;
		this._markerLayer = Scene.createLayerMarker();
		this._geometryLayer = Scene.createLayerGeometry("activity-item");
		this._markers = [];
		this._geometry = null;
		this._geometries = [];
		this._interactiveGeometry = new MapInteractiveGeometry(this, {
			dragAndDrop: false,
		});
		this._lineChart = null;
		this._interactive = null;
		this._loadRequest = null;
		this._contextMenu = null;
		this._likeData = null;
		this._showLabelInFrame = 0;
		this._text = null;
		this._userNote = null;
		this._logger = Mapy.getComponent("logger");
		this._state = {};
		this._dom = {
			container: node("div", { className: "activity-detail" }),
			header: node("div", { className: "header" }),
			myActivitiesButton: node("button", {}, _("mymap.activity.myActivities")),
			closeButton: node("button", {
				type: "button",
				className: "back"
			}, _("back")),
			titleH1: node("h1"),
			date: node("span", { className: "date" }),
			menuButton: node("button", { type: "button", className: "menu" }),
			shareButton: node("button", {
				innerHTML: _("action.share.title"),
				type: "button",
				className: "share-button",
			}),
			download: node("button", { className: "export" }, _("action.download.title"))
		};
		this._dom.download.insertBefore(icon("export2"), this._dom.download.firstChild);
		this._wasmMarkers = [];
		this._wasmGeometry = null;

		this._3dlayer = null;

		this._dom.closeButton.insertBefore(icon("back"), this._dom.closeButton.firstChild);
		this._dom.shareButton.insertBefore(icon("share"), this._dom.shareButton.firstChild);
		this._dom.myActivitiesButton.addEventListener("click", this, false);

		// deaktivace rucniho mereni a vlastnich bodu
		addListener(this, "distancemeter-activated", () => this._disableInteraction());
		addListener(this, "distancemeter-deactivated", () => this._enableInteraction());
		addListener(this, "usermarks-activated", () => this._disableInteraction());
		addListener(this, "usermarks-deactivated", () => this._enableInteraction());
		addListener(this, "print-page", () => this._printPage());
		addListener(this, "print-done", () => this._printDone());

		Scene.addListener("provider-changed", function(event) {
			var data = event.data;

			if (Mapy.getComponent("activities").isActive && data.name == "m3d") {
				if (this._3dlayer) {
					Scene.removeLayer(this._3dlayer);
					Scene.addLayer(this._3dlayer);
				}
				else {
					this._show3DGeometry();
				}
			}
		}, this);
	}

	destroy () {
		this.clear();

		if (this._geometryLayer) {
			Scene.removeLayer(this._geometryLayer);
			this._geometryLayer.destroy();
			this._geometryLayer = null;
		}

		if (this._markerLayer) {
			Scene.removeLayer(this._markerLayer);
			this._markerLayer.destroy();
			this._markerLayer = null;
		}

		this._markers = [];

		if (this._interactiveGeometry) {
			this._interactiveGeometry.destroy();
			this._interactiveGeometry = null;
		}

		for (const wasmMarker of this._wasmMarkers) {
			wasmMarker.destroy();
		}

		this._wasmGeometry?.destroy();

		this._dom.myActivitiesButton.removeEventListener("click", this, false);
	}

	get container () {
		return this._dom.container;
	}

	get state () {
		if (this._active && this._tid && !this._likeData) {
			return { mid: this._tid };
		}
		else {
			return {};
		}
	}

	set state (state) {
		state = state || {};
		this.clear();

		if ("likeData" in state) {
			this._likeData = state.likeData;
			this._state = {
				dim: state.likeData.id,
				...state.onClose ? { onClose: state.onClose } : {},
				...state.backTitle ? { backTitle: state.backTitle } : {},
				...state.backAction ? { backAction: state.backAction } : {},
			};
			this._showLabelInFrame = state.showLabel || 0;
			Mapy.Util.clear(this._dom.container);
			state.likeData.linkdata.usertitle = state.likeData.usertitle;
			this._response({ track: state.likeData.linkdata });
			if (Mapy.getComponent("activities").isActive) {
				Mapy.getComponent("activities").setSEO();
			}
		} else if ("mid" in state && state.mid) {
			this._likeData = null;
			this._state = state;
			this._load(this._state.mid).then(() => {
				if (Mapy.getComponent("activities").isActive) {
					Mapy.getComponent("activities").setSEO();
				}
			}, () => { });
		}
	}

	/**
	 * vrati ulozena data v Moje mapy
	 * @return {Object} data
	 */
	get likeData () {
		return this._likeData;
	}

	get visible () {
		return this._show;
	}

	get activeGeomLayer() {
		return this._geometryLayer;
	}

	get markerLayer() {
		return this._markerLayer;
	}

	get markers() {
		return this._markers;
	}

	get wasmMarkers() {
		return this._wasmMarkers;
	}

	/**
	 * vytvori data pro sdileni
	 * @return {Object} data pro sdileni
	 */
	get shareData () {
		const { mapset, provider } = store.getState().map;

		return {
			id: this._data.id,
			title: this._data.usertitle && this._data.usertitle != "" ? this._data.usertitle : this._data.title,
			type: this._data.type,
			url: `${location.protocol}//${location.host}/${mapset}?moje-mapy&cat=aktivity&mid=${this._data.id}${provider === "m3d" ? "&m3d=1" : ""}`,
			public: this._data.public,
			foreign: this._data.foreign,
			description: this._data.description,
		};
	}

	/**
	 * zmena verejnosti
	 * @param  {boolean} state verejnost
	 */
	changePublic (state) {
		this._data.public = state;
	}

	show () {
		if (this._show) { return; }
		Scene.addLayer(this._geometryLayer);
		Scene.addLayer(this._markerLayer);
		this._geometryLayer.enable();
		this._markerLayer.enable();
		if (this._likeData) {
			Mapy.getComponent("dimcurator").setState({ dim: this._likeData.id });
		}
		this._show = true;
		Mapy.SEO.set(_("mymap.activity.seo"));

		Scene.getContainer().addEventListener("photo-gallery-close", this);
		Scene.getContainer().addEventListener("photo-detail-close", this);

		for (const wasmMarker of this._wasmMarkers) {
			wasmMarker.update({
				visible: true,
			});
		}

		this._wasmGeometry?.update({
			visible: true,
		});
	}

	hide () {
		if (!this._show) { return; }
		this._geometryLayer.disable();
		this._markerLayer.disable();
		if (this._likeData) {
			Mapy.getComponent("dimcurator").setState();
		}
		Scene.removeLayer(this._geometryLayer);
		Scene.removeLayer(this._markerLayer);
		this._show = false;

		Scene.getContainer().removeEventListener("photo-gallery-close", this);
		Scene.getContainer().removeEventListener("photo-detail-close", this);

		for (const wasmMarker of this._wasmMarkers) {
			wasmMarker.update({
				visible: false,
			});
		}

		this._wasmGeometry?.update({
			visible: false,
		});
	}

	activate () {
		if (this._active) { return; }

		this._active = true;

		if (this._show && this._tid) {
			this.state = {
				mid: this._tid,
				...Mapy.getComponent("history").isFromHistory() ? {} : {
					backTitle: this._state?.backTitle ? this._state?.backTitle : _("close"),
					backAction: this._state?.backAction ? this._state?.backAction : backAction,
				},
			};
		}
		else if (this._show && this._likeData) {
			this.state = { likeData: this._likeData };
			Mapy.getComponent("dimcurator").setState({ dim: this._likeData.id });
		}

		window.addEventListener("resize", this, false);

		this._dom.shareButton.addEventListener("click", this, false);
		this._dom.menuButton.addEventListener("click", this, false);
		Mapy.getComponent("layout").getScrollNode().scrollTop = 0;

		return this;
	}

	deactivate () {
		if (!this._active) { return; }

		this._state.onClose && this._state.onClose();
		this._dom.shareButton.removeEventListener("click", this, false);
		this._dom.menuButton.removeEventListener("click", this, false);
		this._active = false;
		if (this._likeData) {
			Mapy.getComponent("dimcurator").setState();
		}
		this.clear();

		window.removeEventListener("resize", this, false);

		this._interactiveGeometry.enabled = false;

		return this;
	}

	handleEvent (e) {
		// FIXME: tohle asi ma byt zavolane, ale nechci menit funkci kodu, ktery uz nekdo mohl odladit s tim, ze preventDefault nefunguje
		//e.preventDefault;
		switch (e.type) {
			case "click":
				if (this._dom.menuButton.contains(e.target)) {
					this._contextMenu.toggle();
				}
				else if (this._dom.closeButton.contains(e.target)) {
					this._tid = null;
					if (this._state.backAction) {
						this._state.backAction(e, this._likeData);
					} else {
						Mapy.getComponent("activities").state = {};
						Mapy.getComponent("search").activate();
						Mapy.getComponent("history").save();
					}
					this._likeData = null;
				}
				else if (this._dom.shareButton.contains(e.target)) {
					this._sharePopupOpen();
				}
				else if (e.target == this._dom.myActivitiesButton) {
					this._tid = null;
					Mapy.getComponent("activities").state = {};
					Mapy.getComponent("history").save();
				}
				break;

			case "resize":
				this._resizeLineChart();
				break;

			case "photo-gallery-close":
			case "photo-photo-close":
				this._active && !Mapy.getComponent("gallery").isActive() && this.setSEO();
				break;
		}
	}

	_load(tid) {
		if (this._loadRequest) {
			this._loadRequest.abort();
			Mapy.getComponent("loader").end(true);
		}

		Mapy.getComponent("loader").start(true);
		this._dom.container.appendChild(Mapy.getComponent("loader").getBigCon());
		this._tid = tid;

		let frpc = Mapy.ProviderMapyBox.trackDetail(this._tid);

		this._loadRequest = frpc.request;
		let rq = frpc.promise;
		rq.then(r => this._response(r), r => this._reject(r));

		return rq;
	}

	_response(response) {
		let bigCont = Mapy.getComponent("loader").getBigCon();
		if (bigCont.parentNode == this._dom.container) {
			bigCont.remove();
		}
		Mapy.getComponent("loader").end(true);

		this._data = response.track;

		if (Mapy.getComponent("activities").isOGPrint) {
			this._buildGeometry();
			this._createOGContent();
		} else if (Mapy.getComponent("activities").isActive || this._likeData) {
			let allCoords = this._buildGeometry();
			this._interactiveGeometry.enabled = true;
			this._interactiveGeometry.start(this._data.data.info.totalLength || 0);
			this._buildColumn(allCoords);
			this._createContextMenu();
			this._show3DGeometry();
			this.setSEO();
		}
	}

	_reject (response) {
		let div = document.createElement("div");
		div.classList.add("track-error");
		let p = document.createElement("p");
		if (response.status == 404) { // existuje, ale nesmim to videt
			p.innerHTML = _("mymap.activity.msgNotFoundOrPrivate");
		} else if (response.status == 403) { // jakakoliv jina chyba
			p.innerHTML = _("mymap.activity.msgNeedLogIn");
		} else {
			p.innerHTML = _("error.info");
		}
		div.appendChild(p);
		div.appendChild(this._dom.myActivitiesButton);
		this._dom.container.appendChild(div);
		let bigCont = Mapy.getComponent("loader").getBigCon();
		if (bigCont.parentNode == this._dom.container) {
			bigCont.remove();
		}
		Mapy.getComponent("loader").end(true);
	}

	clear() {
		if (this._3dlayer) {
			Scene.removeLayer(this._3dlayer);
			this._3dlayer.destroy();
			this._3dlayer = null;
		}

		if (this._interactive) {
			this._interactive.destroy();
			this._interactive = null;
		}

		this._markerLayer.removeAll();
		this._geometryLayer.removeAll();

		this._markers = [];

		if (this._geometry) {
			this._geometry.destroy();
			this._geometry = null;
		}

		while (this._geometries.length) {
			this._geometries.pop().destroy();
		}

		if (this._lineChart) {
			this._lineChart.destroy();
			this._lineChart = null;
		}

		if (this._likeData && this._text) {
			this._text.destroy();
		}

		if (this._userNote) {
			this._userNote.destroy();
		}

		this._text = null;
		this._userNote = null;
		this._data = null;
		this._state = {};

		for (const wasmMarker of this._wasmMarkers) {
			wasmMarker.destroy();
		}

		this._wasmGeometry?.destroy();

		this._wasmMarkers = [];
		this._wasmGeometry = null;

		Mapy.Util.clear(this._dom.container);
	}

	/**
	 * odebrani dat z moje mapy = normalni aktivita
	 */
	clearTid () {
		this._tid = null;

		if (this._likeData) {
			Mapy.getComponent("dimcurator").setState();
			this._likeData = null;
		}
	}

	_buildGeometry () {
		let allCoords = [];

		if (this._data.data.data) {
			let allSingleCoords = [];
			const wasmStrPoints: Array<string> = [];

			this._data.data.data.forEach((geom, index) => {
				let coords = Scene.stringToCoords(geom.route);
				wasmStrPoints.push(geom.route);
				let geometry = Scene.createGeometry(Scene.GEOMETRY.POLYLINE, null, coords, {
					color: "#f00",
					width: 8,
					outlineOpacity: 0
				});

				this._geometryLayer.addGeometry(geometry);
				this._geometries.push(geometry);

				this._interactiveGeometry.clear();
				this._interactiveGeometry.addCoords(index, coords);
				allCoords.push(coords);
				coords.forEach(coord => allSingleCoords.push(coord));
			});

			this._geometry = Scene.createGeometry(Scene.GEOMETRY.POLYLINE, null, allSingleCoords);
			this._wasmGeometry = new WasmStoreGeometry({
				type: "activity-detail",
				strPoints: wasmStrPoints,
				zIndex: WASM_ZINDEX.geometry.activityDetail,
				interactionType: "hover",
				customData: {
					component: "activity",
				},
				...wasmStrPoints.length > 1
					? {
						multilineData: wasmStrPoints.map((item, ind) => ({
							multilineIndex: ind,
							multilineGeometry: item,
						}))
					}
					: {},
			});

			let startSpan = document.createElement("span");
			startSpan.classList.add("text");
			startSpan.innerHTML = _("track.detail.start");

			let marker = Scene.createMarkerWindy(allCoords[0][0], null, {
				type: Scene.VISUAL.MARKER_WINDY["BIG"],
				elm: startSpan,
				m3dData: {
					type: "route",
					value: "start",
				},
			});

			this._markers = [marker];
			this._markerLayer.addMarker(marker);

			let endSpan = document.createElement("span");
			endSpan.classList.add("text");
			endSpan.innerHTML = _("track.detail.end");
			let lastCoords = allCoords[allCoords.length - 1];
			let lastCoordItem = lastCoords[lastCoords.length - 1];
			marker = Scene.createMarkerWindy(lastCoordItem, null, {
				type: Scene.VISUAL.MARKER_WINDY["BIG"],
				elm: endSpan,
				m3dData: {
					type: "route",
					value: "end"
				}
			});

			this._wasmMarkers.push(new WasmStoreMarker({
				type: "route-start",
				lon: allCoords[0][0].x,
				lat: allCoords[0][0].y,
				zIndex: WASM_ZINDEX.marker.activityDetail,
				interactionType: "none",
				customData: {
					component: "activity",
				},
			}), new WasmStoreMarker({
				type: "route-end",
				lon: lastCoordItem.x,
				lat: lastCoordItem.y,
				zIndex: WASM_ZINDEX.marker.activityDetail,
				interactionType: "none",
				customData: {
					component: "activity",
				},
			}));

			this._markers.push(marker);
			this._markerLayer.addMarker(marker);

			if (this._likeData && showMarkerLabel(this._showLabelInFrame, this._likeData.usertitle, this._likeData.title)) {
				let coords = Scene.coordsFromWGS84(this._likeData.mark.lon, this._likeData.mark.lat);
				marker = Scene.createMarkerMapyWindy(coords, null, { type: Scene.VISUAL.MARKER_WINDY.LITTLE });
				marker.setLabel(this._showLabelInFrame === 1 ? this._likeData.usertitle : this._likeData.usertitle || this._likeData.title);
				marker.setStyle("visibility", "hidden");
				marker.getContainer(el => {
					el.classList.add("hidden");
				});
				this._markers.push(marker);
				this._markerLayer.addMarker(marker);
			}

			if (!(("x" in this._state) && ("y" in this._state) && ("z" in this._state))) {
				let cz = this._geometry.computeCenterZoom(true);
				const [longitude, latitude] = cz[0].toWGS84();

				if (cz[1] == Infinity) {
					cz[1] = 17;
				}
				store.dispatch(setCoordinates({
					longitude,
					latitude,
					zoom: cz[1],
					animate: true,
				}));
				Mapy.getComponent("history").save();
			}

			if (CONFIG.inFrame) {
				this._geometryLayer.addEventListener("click", e => {
					Mapy.Util.openInNewWindow();
				});
				Scene.addListener("marker-click", () => {
					Mapy.Util.openInNewWindow();
				});
			}
		} else {
			this._geometry = null;
		}

		return allCoords;
	}

	_buildHeader() {
		const title = Mapy.Util.fragment();
		const h1 = node("h1");
		const date = getUserTime(this._data);

		title.appendChild(createSDSIcon({ symbol: activityTypeToIcon(this._data.data.info.trackType) }));
		h1.innerHTML = Mapy.Util.escapeHTML(this._data.usertitle && this._data.usertitle.trim() != "" ? this._data.usertitle : this._data.title);
		h1.title = h1.textContent;
		title.appendChild(h1);
		title.appendChild(node("span", {}, new Intl.DateTimeFormat(CONFIG.defaultLang).format(new Date(date))));

		this._header = new HeroHeader({
			poster: this._data.img ? Mapy.CDN.setSize(this._data.img, Mapy.CDN.SIZE_400_225) : "/img/header-placeholder.svg",
			title,
		});
		this._dom.container.appendChild(this._header.node);

		const backButton = createHeaderButton({
			icon: this._state.backTitle ? CHEVRON_LEFT_16 : CLOSE_16,
			innerHTML: this._state.backTitle || _("close"),
		});
		this._header.leftButtons.appendChild(backButton);
		backButton.addEventListener("click", this);
		this._dom.closeButton = backButton;

		if (this._data.foreign) {
			const likeButton = createHeaderButton({
				icon: STAR,
				innerHTML: _("mymap.addPopup.title"),
			});
			this._header.rightButtons.appendChild(likeButton);
			likeButton.addEventListener("click", this);
			likeButton.setAttribute("data-log-ignore", "1");
			likeButton.addEventListener("click", () => {
				Mapy.getComponent("logger").log("click", {
					text: "uložit_hvězda",
					type: "activity"
				});

				new MyMapsLinkActivity({
					isPremiumUser: isPremiumNoteUser(),
					noteVersion: getNoteVersion(),
					trackData: this._data,
					onSave: (saveData, folderId) => {
						mymapsOpenFolder(folderId);
					},
				}).open();
			});
		} else {
			const shareButton = createHeaderButton({
				icon: MYMAPS_SHARE,
				innerHTML: _("mymap.contextMenu.share"),
			});
			this._header.rightButtons.appendChild(shareButton);
			shareButton.addEventListener("click", this);
			shareButton.setAttribute("data-log-ignore", "1");
			this._dom.shareButton = shareButton;

			const menuButton = createHeaderButton({
				icon: OVERFLOW_MENU_VERTICAL_FILLED,
				className: "more-options",
			});
			this._header.rightButtons.appendChild(menuButton);
			menuButton.addEventListener("click", this);
			this._dom.menuButton = menuButton;
		}
	}

	_buildColumn(allCoords) {
		this._dom.container.innerHTML = "";

		let frag = Mapy.Util.fragment();

		this._buildHeader();

		const textData = this._likeData
			? {
				...this._likeData,
				...this._likeData.linkdata,
			}
			: this._data;

		if (textData.foreign) {
			frag.appendChild(createMyMapsSharing({
				data: textData,
			}));

			if (textData.description) {
				this._userNote = createUserNote({
					data: textData,
					foreign: true,
				});

				frag.append(this._userNote.container);
			}
		} else if (textData) {
			const noteVersion = getNoteVersion();

			this._text = new MyMapsBox({
				isPremiumUser: isPremiumNoteUser(),
				noteVersion: getNoteVersion(),
				data: textData,
				...textData.linktype === "track"
					? {
						folder: {
							id: textData.parent_id || "",
							title: textData.parent_name,
						},
					}
					: {},
				onSignal: signal => {
					switch (signal.name) {
						case "like-update":
							if (this._likeData) {
								Object.assign(this._likeData, signal.updateData);
							}

							if (this._data) {
								Object.assign(this._data, signal.updateData);
							}
							break;

						case "track-link-delete":
							this._refreshContextMenu();
							break;

						case "delete":
							if (textData.linktype === "track") {
								// link aktivity
								mymapsOpenFolder(textData.parent_id);
							} else {
								// aktivita
								mymapsOpenActivities();
							}
							break;

						case "like-move":
							if (this._likeData) {
								this._likeData.parent_id = signal.folderId;
								this._likeData.parent_name = signal.folderTitle;
							}

							if (this._data) {
								this._data.parent_id = signal.folderId;
								this._data.parent_name = signal.folderTitle;
							}

							this._refreshContextMenu();
							break;

						default:
					}
				},
			});

			frag.appendChild(this._text.container);
		}

		// statistiky
		let stats = node("ul", { className: "stats" });
		let distance = standardDistanceFormat(this._data.data.info.totalLength);
		let formatTime = standardTimeFormat(this._data.data.info.totalTime, true);
		let avgSpeed = {
			average: Mapy.Util.formatLocaleNumber(Mapy.Util.formatNumber(parseFloat(this._data.data.info.avgSpeed >= 1 ? this._data.data.info.avgSpeed : this._data.data.info.avgSpeed * 1000), 1, true)),
			unit: this._data.data.info.avgSpeed >= 1 ? "km/h" : "m/h"
		};

		[
			{ value: formatTime.time, sub: formatTime.unit, sup: _("mymap.activity.totalTime") },
			{ value: distance.distance, sub: distance.unit, sup: _("mymap.activity.distance") },
			{ value: avgSpeed.average, sub: avgSpeed.unit, sup: _("mymap.activity.avgSpeed") }
		].forEach(item => {
			let li = node("li");
			let target = li;

			let sup = node("small", {
				innerHTML: item.sup,
				className: "sup"
			});

			let value = node("strong", {
				innerHTML: item.value
			});

			let sub = node("small", {
				innerHTML: item.sub,
				className: "sub"
			});

			target.appendChild(sup);
			target.appendChild(value);
			target.appendChild(sub);

			stats.appendChild(li);
		});
		frag.appendChild(stats);

		// tempo a rychost
		let tempoTimeValue = Math.floor(3600 / this._data.data.info.avgSpeed);
		let tempoTime = standardTimeFormat(Math.max(tempoTimeValue, 1), true);
		let tempoTotal = `${_("mymap.activity.tempo")} <strong>${tempoTime.time}</strong> ${tempoTime.unit}`;
		let maxSpeed = Mapy.Util.formatLocaleNumber(Mapy.Util.formatNumber(this._data.data.info.maxSpeed, 0, true));
		let tempoTotalEl = node("p", { className: "total-tempo", innerHTML: tempoTotal });
		let maxSpeedEl = node("p", { className: "max-speed", innerHTML: `${_("mymap.activity.maxSpeed")} <strong>${maxSpeed}</strong> km/h` });

		frag.appendChild(tempoTotalEl);
		frag.appendChild(maxSpeedEl);

		if ("mood" in this._data && this._data.mood != "") {
			let mood = node("div", { className: "mood" });
			mood.appendChild(node("p", { className: "mood-info", textContent: _("mymap.activity.edit.mood") }));
			let ico = icon(moodIco(this._data.mood));
			mood.appendChild(ico);
			frag.appendChild(mood);
		}

		this._dom.container.appendChild(frag);

		this._buildChart(undefined, {
			activityData: this._data.data,
			width: (this._dom.container.offsetWidth ? this._dom.container.offsetWidth : 400) - 2 * 16
		}, allCoords);

		if (this._lineChart) {
			this._dom.container.appendChild(this._lineChart.getContainer());
		}

		this._resizeLineChart();
		Mapy.getComponent("mymaps").getContainer().classList.remove("empty");
	}

	_buildChart(altitudes, options, allCoords) {
		try { // kdyz dojdou spatna data z backendu, tak abychom nevyhnmili, ale zobrazili vsechno ostatni, krome vyskoveho profilu
			this._lineChart = new LineChart(altitudes, this._data.data.info.totalLength, options);
		} catch (ex) {
			// eslint-disable-next-line no-console
			console.log(ex);
		}

		if (this._geometry && this._lineChart) {
			this._interactive = new InteractiveLineChart(this._lineChart, this._data.data.data.length > 1 ? allCoords : this._geometry, {
				...this._data.data.data.length > 1
				? {
					trackWithSpace: true,
					trackLength: this._data.data.info.totalLength,
				}
				: {},
				interactiveGeometry: this._interactiveGeometry,
				config: CONFIG,
			});
		}
	}

	_formatElevation (elevation) {
		return {
			value: Mapy.Util.formatLocaleNumber((elevation >= 1000 ? Mapy.Util.formatNumber(elevation / 1000, 2, true) : Mapy.Util.formatNumber(elevation, 0, true))),
			unit: elevation >= 1000 ? "km" : "m"
		};
	}

	async _createContextMenu () {
		const item = this._likeData || this._data;
		const links = await trackListFolders(item.id);
		const hasLinks = links.length > 0;
		const isTrackLinkActivity = item?.linktype === "track";
		const contextMenu = new ContextMenu({
			anchor: this._dom.menuButton,
			position: "bottom-end",
			offset: 8,
		});

		[
			"edit",
			"export",
			hasLinks || isTrackLinkActivity
				? "link-to-another-folder"
				: "link-to-folder",
			...links.length === 1
				? [
					"activity-move-to-folder",
					"activity-remove",
				] as Array<TMymapsContextMenuName>
				: [
				],
			hasLinks || isTrackLinkActivity
				? "delete-from-all"
				: "delete",
		].forEach(name => {
			contextMenu.container.appendChild(new ContextMenuItem({
				icon: contextmenuGetIcon(name),
				text: contextmenuGetTitle(name),
				onClick: event => {
					event.stopPropagation();
					contextMenu.close();
					contextMenu.destroy();
					this._contextMenuAction(name)
				},
				destructive: ["delete", "delete-from-all"].includes(name),
			}).container);
		});
		this._contextMenu = contextMenu;
	}

	setSEO () {
		if (!this._data) {
			return;
		}
		var title = this._data.usertitle || this._data.title || "";
		title = _("mymap.switcher.activities") + (title ? ": " + title : "");
		var descr = _("mymap.activity.myActivitiesDesc1") + "\n" + _("mymap.activity.myActivitiesDesc2");

		Mapy.SEO.set(title, descr);

		if (Mapy.getComponent("print").mode === 3) {
			this._printMode3();
		}
	}

	/**
	 * metoda pro nastavení stránky, pokud je printMode = 3 - sdílení
	 */
	_printMode3 () {
		Mapy.getComponent("layout").setWidth(1);
		Mapy.getComponent("layout").getContent().classList.add("track-print");
	}

	_refreshContextMenu() {
		// refreshneme context menu
		this._contextMenu?.close();
		this._contextMenu?.destroy();
		this._contextMenu = null;
		this._createContextMenu();
	}

	async _moveActivity() {
		// aktivita - jedno pripojeni do slozky je v _data
		let item: IMapyBoxItem = null;
		let actId = "";
		let parentId = "";
		let parentTitle = "";

		if (this._likeData) {
			item = this._likeData;
			actId = this._likeData.id;
			parentId = this._likeData.parent_id;
			parentTitle = this._likeData.parent_name;
		} else if (this._data) {
			item = this._data;

			const linkFolders = await trackListFolders(this._data.id);

			if (linkFolders.length === 1) {
				const curLink = linkFolders[0];

				actId = curLink.track_link_id;
				parentId = curLink.id;
				parentTitle = curLink.title;
			} else {
				return;
			}
		}

		new MyMapsMoveItems({
			item,
			ids: [actId],
			moveFolders: [{
				id: parentId,
				title: parentTitle,
			}],
			onSave: (folderId, folderTitle) => {
				Mapy.getComponent("places").listRefreshData();
				this._text?.refreshTrackList();
			},
		}).open();
	}

	async _deleteActivity(action) {
		let item: IMapyBoxItem = null;
		let realDelete = false;

		if (this._likeData) {
			item = this._likeData;
		} else {
			const linkFolders = await trackListFolders(this._data.id);

			if (linkFolders.length === 1) {
				const curLink = linkFolders[0];

				item = {
					...this._data,
					type: "link",
					linktype: "track",
					id: curLink.track_link_id,
				};
			} else {
				item = this._data;
				realDelete = true;
			}
		}

		new MyMapsRemove({
			data: item,
			operation: action === "activity-remove"
				? "remove"
				: "delete",
			onRemove: () => {
				if (realDelete) {
					this._tid = null;
					Mapy.getComponent("activities").list.loadData(true, true);
					Mapy.getComponent("activities").state = {};
					Mapy.getComponent("history").save();
				} else {
					this._text?.refreshTrackList();
					this._refreshContextMenu();
				}
			},
		}).open();
	}

	_contextMenuAction (action) {
		switch (action) {
			case "share":
				this._sharePopupOpen();
				break;

			case "add-to-folder":
			case "link-to-folder":
			case "link-to-another-folder":
				new MyMapsLinkActivity({
					isPremiumUser: isPremiumNoteUser(),
					noteVersion: getNoteVersion(),
					trackData: this._data,
					type: action === "link-to-another-folder"
						? "link-to-another-folder"
						: "link-to-folder",
					onSave: saveData => {
						this._userNote?.setNote(saveData.description);
						this._text?.refreshTrackList();
						this._refreshContextMenu();
					},
				}).open();
				break;

			case "activity-move-to-folder":
				this._moveActivity();
				break;

			case "edit":
				const noteVersion = getNoteVersion();

				new MyMapsEditActivity({
					isPremiumUser: isPremiumNoteUser(),
					noteVersion: getNoteVersion(),
					data: this._data,
					onSave: updData => {
						Object.assign(this._data, updData);
						Mapy.getComponent("dimcurator").loadData();
						Mapy.getComponent("activities").list.loadData(true, true);

						Mapy.Util.clear(this._dom.container);
						this._response({ track: this._data });
					},
				}).open();
				break;

			case "activity-remove":
			case "delete":
			case "delete-from-all": {
				this._deleteActivity(action);
				break;
			}

			case "export": {
				let mid = "";
				let title = "";

				if (this._data) {
					mid = this._data.id;
					title = this._data.title;
				} else if (this._likeData) {
					mid = this._likeData.linkid || this._likeData.id;
					title = this._likeData.title;
				}

				new MyMapsExport({
					data: {
						name: "activity",
						data: {
							mid,
							title,
						},
					},
				}).open();
				break;
			}
		}
	}

	_dataToEdit () {
		return {
			title: this._data.usertitle && this._data.usertitle != "" ? this._data.usertitle : this._data.title,
			id: this._data.id,
			description: this._data.description,
			type: this._data.data.info.trackType,
			mood: this._data.mood,
			public: this._data.public
		};
	}

	_sharePopupOpen () {
		const { mapset, provider } = store.getState().map;

		let sharePopup = new MyMapsShare({
			id: this._data.id,
			title: this._data.usertitle && this._data.usertitle != "" ? this._data.usertitle : this._data.title,
			type: this._data.type,
			url: `${location.protocol}//${location.host}/${mapset}?${this._likeData ? `dim=${this._likeData.id}` : `moje-mapy&cat=aktivity&mid=${this._data.id}`}${provider === "m3d" ? "&m3d=1" : ""}`,
			public: this._data.public,
			like: true,
			showLabel: true
		}, cbData => {
			if (cbData.name == "popup-close" && this._data) {
				this._data.public = cbData.public;
				if (this._data.public) {
					let logData = {
						text: "sdílet",
						origin: "my_maps",
						type: "activity"
					};
					this._logger.log("click", logData);
				}
			}
		});
		sharePopup.open();
	}

	_resizeLineChart () {
		if (this._lineChart) {
			this._lineChart.setData(undefined, undefined, { width: (this._dom.container.offsetWidth ? this._dom.container.offsetWidth : 400) - 2 * 16 });
		}
	}

	_createOGContent () {
		let ogContent = node("div", { className: "og-content" });
		let trackTypeIcon = createSDSIcon({ symbol: activityTypeToIcon(this._data.data.info.trackType) });
		let timeData = standardTimeFormat(parseInt(this._data.data.info.totalTime), true);
		let distanceData = standardDistanceFormat(this._data.data.info.totalLength);
		let distance = node("strong", { className: "distance", textContent: distanceData.string });
		let forSpan = node("span", { className: "for", textContent: _("route.ogContent") });
		let time = node("strong", { className: "time", textContent: timeData.string });
		let circleSpan = node("span", { className: "circle", textContent: "•" });
		let ascendingIcon = icon("ascending");
		let descendingIcon = icon("descending");
		let altitude = this._data.data.info.sznAltitude && "gain" in this._data.data.info.sznAltitude
			? this._data.data.info.sznAltitude
			: {
				gain: 0,
				loss: 0,
			};
		let ascending = node("strong", { textContent: altitude.gain.toLocaleString() + " m" });
		let descending = node("strong", { textContent: altitude.loss.toLocaleString() + " m" });

		ogContent.appendChild(trackTypeIcon);
		ogContent.appendChild(distance);
		ogContent.appendChild(forSpan);
		ogContent.appendChild(time);
		ogContent.appendChild(circleSpan.cloneNode(true));
		ogContent.appendChild(ascendingIcon);
		ogContent.appendChild(ascending);
		ogContent.appendChild(circleSpan.cloneNode(true));
		ogContent.appendChild(descendingIcon);
		ogContent.appendChild(descending);

		let overlay = node("div", { className: "bottom-overlay" });
		overlay.appendChild(ogContent);
	}

	_disableInteraction () {
		if (this._active) {
			this._markerLayer.disableInteraction();

			this._geometries.forEach(geom => {
				geom.setOptions({
					color: "#6b7580"
				});
			});
		}
	}

	_enableInteraction () {
		if (this._active) {
			this._markerLayer.enableInteraction();

			this._geometries.forEach(geom => {
				geom.setOptions({
					color: "#f00"
				});
			});
		}
	}

	_printPage () {
		if (!this._active) { return; }

		if (this._text && this._text.container) {
			this._dom.header.classList.add("with-like-text");
			this._text.print();
		}

		if (this._userNote) {
			this._userNote.print();
		}

		const printMode = Mapy.getComponent("print").mode;

		// 4 = stahnout jako obrazek, 0 tisk
		if (this._lineChart && printMode !== 4) {
			this._lineChart.setData(undefined, undefined, {
				width: 700
			});
		}
	}

	_printDone () {
		if (!this._active) { return; }

		this._dom.header.classList.remove("with-like-text");

		if (this._lineChart) {
			this._lineChart.setData(undefined, undefined, {
				width: 400 - 2 * 16
			});
		}
	}

	_show3DGeometry() {
		if (!Scene.isM3dActive() || !this._data) return;

		let geometryLine = this._data.data.info.sznAltitude.data.map(i => [i.lon, i.lat]);

		this._3dlayer = Scene.createLayerFree("activity", [geometryLine], {
			lineOffset: [-0.19, 0, 0],
			outlineOffset: [-0.19, 0, 0]
		});
		Scene.addLayer(this._3dlayer);
	}
}
